import { render, staticRenderFns } from "./UserImport.vue?vue&type=template&id=620280ad&"
import script from "./UserImport.vue?vue&type=script&lang=ts&"
export * from "./UserImport.vue?vue&type=script&lang=ts&"
import style0 from "./UserImport.vue?vue&type=style&index=0&id=620280ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports